import React, { useEffect, useState } from 'react';
import { getItems, deleteItems } from '~/services/hooks/items';
import Box from '~/components/Box';
import { Table, TableHeader } from '~/components/Table';
import { Col, Input, message } from 'antd';
import Pagination from '~/components/Pagination';
import Global from '~/styles/global';
import { useTranslation } from 'react-i18next';
import Button from '~/components/Button';
import ItemsModal from './form';
import { useCheckAuth } from '~/components/Can/checkAuth';
import ColButton from '~/components/ColButton';
import IsMobile from '~/services/mobileCheck';
import ItemView from './view';
import { itemsColumns } from '~/tables/items';
import errorHandler from '~/Utils/errorHandler';

export default function Items() {
  const { t } = useTranslation();
  const authCheck = useCheckAuth();
  const isMobile = IsMobile();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [meta, setMeta] = useState({});
  const [search, setSearch] = useState('');
  const [itemsEdit, setItemsEdit] = useState({});
  const [ModalVisible, setModalVisible] = useState(false);
  const [viewVisible, setViewVisible] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {
        params: {
          page,
          perPage,
          search,
        },
      };
      const data = await getItems(params);
      setData(data.data);
      setMeta(data.meta);
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
    setLoading(false);
  };

  const handleEdit = (record, view = false) => {
    setItemsEdit(record);
    view ? setViewVisible(true) : setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await deleteItems(id);
      message.success(t('Produto excluído'));
      fetchData();
    } catch (error) {
      console.error(error);
      errorHandler(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, perPage, search]);

  return (
    <Box>
      <ColButton>
        <Button color="primary" onClick={() => handleEdit(null)} disabled={!authCheck('@products/create')}>
          {t('screens:items.addItem')}
        </Button>
      </ColButton>
      <TableHeader>
        <Col style={{ display: 'flex' }}>
          <Input.Search
            onSearch={(value) => {
              setSearch(value);
              setPage(1);
            }}
            className="search-field"
            placeholder={t('screens:default.search')}
          />
        </Col>
      </TableHeader>
      <Table
        pagination={false}
        rowKey="id"
        loading={loading}
        dataSource={data}
        columns={itemsColumns(handleEdit, handleDelete, isMobile)}
        bordered
      />
      <Pagination
        isMobile={isMobile}
        onChange={(value) => {
          setPage(value);
        }}
        meta={meta}
        perPage={perPage}
        setPerPage={setPerPage}
      />
      <Global />
      <ItemView
        visible={viewVisible}
        item={itemsEdit}
        isMobile={isMobile}
        onClose={() => {
          setViewVisible(false);
          setItemsEdit(null);
        }}
      />
      <ItemsModal
        visible={ModalVisible}
        itemsEdit={itemsEdit}
        isMobile={isMobile}
        onClose={() => {
          setModalVisible(false);
          setItemsEdit(null);
          fetchData();
        }}
      />
    </Box>
  );
}
